module.exports = __webpack_public_path__ + "img/youliao.3f5804fd.png";